import { useMemo } from 'react';
import { CellTypes, Column } from '~/Components/DataTable/DataTable.types';
import { useLanguage } from '~/Hooks';

type IVoDVideoColumnType = 'name' | 'uploadDate' | 'status';

export const useVoDVideosListColumns = () => {
  const { t } = useLanguage();

  const columnMap: {
    [key in IVoDVideoColumnType]: Column;
  } = useMemo(
    () => ({
      name: {
        label: t('vod.name'),
        propertyIds: 'name',
        cellType: CellTypes.String,
        formatter: (value: string) => value,
      },
      uploadDate: {
        label: t('vod.uploadDate'),
        propertyIds: 'releaseDate',
        cellType: CellTypes.String,
        formatter: (value: string) => value && new Date(value).toDateString(),
      },
      status: {
        label: t('vod.status'),
        propertyIds: 'status',
        cellType: CellTypes.String,
        formatter: (value: string) => t(`vod.status.${value}`),
      },
    }),
    [t],
  );

  return { columnMap };
};
